<template>
  <div class="help-container">
    <div class="header">
      <img v-if="avatarUrl" :src="avatarUrl" class="widget-icon" alt="Widget icon"/>
      <div>
        <div class="widget-title">{{ webChannelConfig.welcomeTitle }}</div>
        <div class="widget-tagline">{{ webChannelConfig.welcomeTagline }}</div>
      </div>
    </div>
    <articles-listing key="articles-listing" v-bind:pinnedArticles="kbDetails.pinnedArticles" />
  </div>
</template>
<script>
import ArticlesListing from "../components/ArticlesListing";
import { mapGetters } from 'vuex';

export default {
  name: 'Help',
  components: {
    ArticlesListing
  },
  computed: {
    ...mapGetters({
      kbDetails: 'kbDetails/getKbDetails',
      webChannelConfig: 'appConfig/getWebChannelConfig'
    }),
    avatarUrl() {
      return this.webChannelConfig.avatarUrl;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~widget/assets/scss/_articlesInChat.scss";
</style>
